/* eslint-disable */
import React, { useState, useEffect } from 'react'
import { Radio } from 'antd'
import { handleControl } from './control'
import { renderLabelString, renderTextUn } from '@/utils/renderUtils'

const I2RadioButtonC = (props) => {
  const {
    propsClassName, propsStyle, propsClassSpan, style,// 样式 className
    modalProps, label, ending, optionDisabled,// 组件 功能参数
    options, query, value, searchKey, // 组件 数据源
    clearKey, killPending, reduxObj, dropdownRender,// 请求相关控制数据
    action, actionChange, resAction, headerchange // 请求方法
  } = props

  const handleValue = query[searchKey]
  
    const [ useValue, setUseValue ] = useState(handleValue)
    useEffect(() => {
      setUseValue(handleValue)
    }, [query.refQ, query[searchKey]]) // 监听是否要重置

  const onChangeRadio = (e) => {
    const value = e.target.value
    console.log('onChangeRadio', value)
    setUseValue(value)
    // ----- 处理数据 -----------
    let formatValue = value
    // ----- 提交组件 -----------
    handleControl(
      props,
      { [searchKey]: formatValue }
    )
  } 
  return (
    <div className={propsClassName} style={propsStyle}>
      <span className={propsClassSpan} style={{ marginRight: '-2px' }}>{renderLabelString(label)}</span>
      <Radio.Group
        style={style}
        buttonStyle="solid"
        {...modalProps}
        onChange={onChangeRadio}
        value={useValue}>
        {options.map(item => {
          return (
            <Radio.Button key={item.id} value={item.id}>{item.value}</Radio.Button>
          )
        })}
      </Radio.Group>
    </div>
  )
}
export default I2RadioButtonC

I2RadioButtonC.defaultProps = {
  propsClassName: 'mode',
  propsClassSpan: '',
  style: { minWidth: 200 },
  modalProps: {},
  optionDisabled: () => {},
  query: {},
  options: [],
  ending: false,
  killPending: false,
  dropdownRender: false
}
